@if (menuItem) {
  <a mat-menu-item id="changeLangBtn" (click)="toggleLang()">
    <mat-icon *appIfOnline>chat_bubble</mat-icon>
    <span>{{ nextLng }}</span>
  </a>
}
@if (!menuItem) {
  <a mat-button id="changeLangBtn" (click)="toggleLang()">
    <mat-icon *appIfOnline>chat_bubble</mat-icon>
    <span>{{ nextLng }}</span>
  </a>
}
